import { Component, OnInit, OnDestroy, Input } from "@angular/core";
import { DataSharingService } from "../../../core/data-sharing/data-sharing.service";

import { Subscription } from "rxjs";
import { DeviceDetectorService } from "ngx-device-detector";
import { ActivatedRoute, Router, NavigationEnd } from "@angular/router";
import { Post, PostGroupP } from "../../../data/blog-client-api";
import { BlogDataRestService } from "../../../data/blog/blog-data-rest.service";

@Component({
  selector: "app-blog-grid",
  templateUrl: "./blog-grid.component.html",
  styleUrls: ["./blog-grid.component.css"],
})
export class BlogGridComponent implements OnInit, OnDestroy {
  blogs: Post[] = [];
  isDesktop: boolean;
  @Input() blogGroup: PostGroupP;
  @Input() isBlack: boolean;
  routerSubs: Subscription;
  blogGroupID: number;
  isBlog: boolean = false;

  constructor(
    private deviceService: DeviceDetectorService,
    private blogService: BlogDataRestService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.isDesktop = this.deviceService.isDesktop();

    this.routerSubs = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url.includes("blogGrid")) {
          this.getBlogGroup();
        }
      }
    });
  }

  ngOnInit() {
    console.log("blog-grid.comp: ", this.blogGroup);

    if (this.router.url.includes("blogGrid")) {
      var marginTop: string;
      if (this.isDesktop) {
        marginTop = "80px";
      } else {
        marginTop = "50px";
      }
      document.getElementById("pageHeader").style.marginTop = marginTop;
    }

    if (!this.blogGroup) {
      this.getBlogGroup();
    } else {
      this.sortBlog(this.blogGroup.posts)
    }
  }

  sortBlog(blogs: Array<Post>) {
    blogs.forEach(blog => {
      blog.postContents.sort((a, b) => {
        return  +new Date(b.date) - +new Date(a.date);
      });
    });
    this.blogs = blogs;
  }

  getBlogGroup() {
    this.blogGroupID = +this.route.snapshot.paramMap.get("id");
    this.isBlog = this.blogGroupID == 228;
    this.blogService.getBlogGroupById(this.blogGroupID).subscribe((data) => {
      if (data) {
        this.blogGroup = data;
        this.sortBlog(this.blogGroup.posts)
      }
    });
  }

  routeDetail(id: number) {
    this.router.navigateByUrl("blogDetail/" + id);
  }

  routeContentDetail(blog: Post) {
    console.log("blogid: ", blog.id);
    console.log("blog postcontentid: ", blog.postContents[0].id);
    
    this.router.navigateByUrl("blog/" + blog.id + "/" + blog.postContents[0].id);
  }

  ngOnDestroy() {
    if (this.routerSubs) {
      this.routerSubs.unsubscribe();
      this.routerSubs = null;
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/views/blog/blog-grid/blog-grid.component.ts